import { Form, InputNumber } from 'antd';
import { FC } from 'react';

const RemindDays: FC = () => {
  return (
    <Form.Item name="remindDays" rules={[{ message: '请填写', required: true }]}>
      <InputNumber min={0} precision={0} />
    </Form.Item>
  );
};
export default RemindDays;
